module.exports = "<div class=\"pnd-DeliveryWindowTimeRenderer\" [innerHTML]=\"htmlSnippet\"></div>\n"